// User Roles for the ADLTrack application
export const UserRole = {
  FAMILY: 'family',
  CAREGIVER: 'caregiver'
};

// Task status types
export const TaskStatus = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  MISSED: 'missed',
  PROPOSED: 'proposed'
};

// Priority levels
export const Priority = {
  CRITICAL: 'critical',
  HIGH: 'high',
  STANDARD: 'standard',
  LOW: 'low',
  QUALITY_OF_LIFE: 'quality_of_life'
};

// Vital types
export const VitalType = {
  BLOOD_PRESSURE: 'BP',
  TEMPERATURE: 'TEMP',
  HEART_RATE: 'HR',
  PAIN: 'PAIN',
  OXYGEN: 'O2'
};

// Message types for chat
export const MessageType = {
  TEXT: 'text',
  IMAGE: 'image',
  SYSTEM: 'system'
};
